import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, ChangeDetectorRef, ViewChildren, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { UtilsService } from '../../../services/utils/utils.service';
import { ValidationDiscountService } from '../../../../core/providers/services/validation-discount/validation-discount.service';
import { AmbitosPaisesService } from '../../../../core/providers/services/ambitos-paises/ambitos-paises.service';
import { SelectMultipleValueModel } from '../../../../core/models/select-multiple.model';
import { CotizarService } from '../../../../core/providers/services/cotizar/cotizar.service';
import { SobreprimasService } from '../../../../core/providers/services/sobreprimas/sobreprimas.service';
import { DocumentsService } from 'src/app/core/providers/services/documents/documents.service';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import BudgetStepOne from './calc-budget-step-one.componet-utils';
import { DOCUMENTS_CONST, Numbers } from 'src/app/utils/constants';
import CalcBudgetStepOneUtilsExtendedComponent from './calc-budget-step-one.componet-utils-extended';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';
@Component({
  selector: 'app-calc-budget-step-one',
  templateUrl: './calc-budget-step-one.component.html',
  styleUrls: ['./calc-budget-step-one.component.scss']
})

export class CalcBudgetStepOneComponent implements OnInit, OnDestroy {
  tokenURL: any = '';
  Utils: BudgetStepOne;
  utilsExtended: CalcBudgetStepOneUtilsExtendedComponent;
  /**
   * @params fb
   * @params vdSrv
   * @params apSrv
   * @params cotSrv
   * @params utilsSrv
   * @params sobreprimasSrv
   * @params commons
   * @params document
   * @params gtmService
   * @params brokerService
   * @params activatedRoute
   */
  constructor(
    private fb: FormBuilder,
    private vdSrv: ValidationDiscountService,
    private apSrv: AmbitosPaisesService,
    readonly cotSrv: CotizarService,
    private utilsSrv: UtilsService,
    private sobreprimasSrv: SobreprimasService,
    readonly commons: CommonService,
    readonly document: DocumentsService,
    readonly gtmService: GoogleTagManagerService,
    readonly renderer: Renderer2
  ) {
    this.fb = fb;
    this.vdSrv = vdSrv;
    this.apSrv = apSrv;
    this.cotSrv = cotSrv;
    this.utilsSrv = utilsSrv;
    this.sobreprimasSrv = sobreprimasSrv;
    this.commons = commons;
    this.document = document;
    this.gtmService = gtmService;
    this.renderer = renderer;
    this.Utils = new BudgetStepOne(this.gtmService, this.commons, this.utilsSrv, this.cotSrv, this.renderer);
    this.utilsExtended = new CalcBudgetStepOneUtilsExtendedComponent(this.utilsSrv);
  }

  @Input() FORM_DATA: FormGroup;
  @Input() FORM_CONFIG: any;
  @Input() CLICK_BTN_POS: string;
  @Input() productosCorreduria: ProductIdCorreduria[] = [];
  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @ViewChild('chips', { static: false }) chips: any;
  @ViewChildren('select') selecter: any;
  finish = new Subject();
  currentStep = 0;
  public showModal = false;
  displayModal: boolean;
  public showModal2 = false;
  displayModal2: boolean;
  public showModal3 = false;
  displayModal3: boolean;
  insureSelected: string;
  sobreprimasList: any[];
  formDataValue: any;
  numberOfInsuredList: any; // Lista de apoyo a el numero de asegurados
  yearsList: any[]; // Lista de apoyo a el numero de asegurados de 70 años
  sportList: any[]; // Lista de apoyo a el numero de asegurados deporte
  showGuaranteeTable: any;
  numberOfInsuredMax = 0;
  hideGuaranteeTable = false;
  numberOfInsuredChange = false;
  countryDestinyMulti: boolean;
  isOrigenSpain = true;
  requireChangeV: boolean = null;
  isInvalid = true;
  maxDate: any;
  destinyChange: any;
  sportMultipleChange: any;
  petInsuredsChange: any;
  numInsuredChange: { name: string, value: any };
  sportChange: { name: string, value: any };
  countryChange: { name: string, value: any };
  destinyChange2: { name: string, value: any };
  disabledDestiny = false;
  disabledDestiny2 = false;
  idProduct = 0;
  documentsConst: any = DOCUMENTS_CONST;
  insuranceTime: any;
  /**
   * @description Metodo que se ejecuta al inicio
   */
  ngOnInit() {
    const itemsToRemove = ['layer1', 'layer2', 'budget', 'email', 'ndc', 'stepThanks', 'pay', 'resetForm'];
    this.utilsExtended.localStoregaRemoveItems(itemsToRemove);

    let isPrevious = false;
    if (localStorage.getItem('prev-step1') !== null) {
      isPrevious = true;
    }
    this.currentStep = this.FORM_CONFIG.currentStep.value;
    this.insureSelected = this.FORM_CONFIG.numberOfInsured.linkFormPath[0];
    if (!isPrevious) {
      localStorage.removeItem('s1Duration');
      sessionStorage.removeItem('radio-card');
      this.FORM_DATA.get([this.insureSelected, 'insuranceDuration']).setValue('Temporal');
    }
    this.numberOfInsuredList = this.FORM_CONFIG.numberOfInsured;
    this.FORM_DATA.get([this.insureSelected, 'numberOfInsuredList']);
    this.FORM_DATA.get([this.insureSelected, 'numberOfInsuredList']).setValue(this.numberOfInsuredList.options.list);
    if (this.FORM_DATA.get([this.insureSelected, 'countryOrigin']).value.name === undefined &&
        this.insureSelected !== 'individualTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'countryOrigin']).setValue({ name: 'España', id: Numbers.number19001 });
      const auxOrigin: any = this.FORM_DATA.get([this.insureSelected, 'countryOrigin']).value;
      this.Utils.getEnvironmentCountry(auxOrigin, [this.insureSelected, 'countryOriginEnvironment'], this.FORM_DATA, this.apSrv);
    }
    this.yearsList = this.FORM_CONFIG.insuredOlderThan70years;
    this.sportList = this.FORM_CONFIG.insuredsPlayRiskSports;

    const auxDurationValue: any = this.FORM_DATA.get([this.insureSelected, 'insuranceDuration']).value;
    if (isPrevious) {
      this.insuranceTime = auxDurationValue;
      if (auxDurationValue.indexOf('form1') > -1) { this.insuranceTime = this.utilsSrv.getTranslate(auxDurationValue); }
      localStorage.removeItem('prev-step1');
    }
    this.countryDestinyMulti = false;
    if (auxDurationValue === '' || auxDurationValue === 'form1.duration-temporal'
    || auxDurationValue === 'form3.duration-temporal' || auxDurationValue === 'Temporal') {
      this.countryDestinyMulti = true;
    }
    if (auxDurationValue !== '') {
      this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
      this.isInvalid = true;
      if (this.FORM_DATA.get(this.insureSelected)) { this.isInvalid = false; }
    }
    const garanteesListAux: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).value;
    if (garanteesListAux.length > 0) {
      this.showGuaranteeTable = true;
    }
    this.utilsExtended.setValidator(this.FORM_DATA, this.insureSelected);
    this.initObs();
    if (this.insureSelected === 'individualTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).setValue(
        this.FORM_CONFIG.guaranteeLimitOfMedicalExpenses.options.list[0]);
      this.FORM_DATA.get([this.insureSelected, 'insuranceDuration']).setValue('Temporal');
    }
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * initObs
   */
  initObs(): void {
    this.FORM_DATA.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
          setTimeout(() => {
            this.checkFamily();
          }, Numbers.number100);
        })
      ).subscribe();
    const args: any = {
      formData: this.FORM_DATA,
      insureSelected: this.insureSelected,
      fb: this.fb,
      numberOfInsuredChange: this.numberOfInsuredChange,
      numberOfInsuredMax: this.numberOfInsuredMax,
      finish: this.finish
    };

    this.Utils.getNumberOfInsured(args);
    this.getGuaranteeLimitOfMedicalExpenses();
    this.getInsuredOlderThan70years();
    this.getInsuredsPlayRiskSports();
    this.getCountryDestinyFormData();
    this.getCuntryOrigin();
    this.getCurrentlyTraveling();
    this.getDateStart();
    this.getDateEnd();
    this.getAllInsuredSameFamiliarUnit();
    this.getHasCodeDerogation();
    this.setSportMultipleChange();
    this.getHasPetsInsurance();
    this.getPetInsureds();
  }

  /**
   * setSportMultipleChange
   */
  setSportMultipleChange(): void {
    if (this.insureSelected === 'sportTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'sports']).valueChanges
        .pipe(
          takeUntil(this.finish),
          tap((sport: SelectMultipleValueModel) => {
            this.sportMultipleChange = { name: 'sports', value: sport };
          })
        ).subscribe();
    }
  }
  /**
   * @description obtener límite de garantía de gastos médicos
   */
  getGuaranteeLimitOfMedicalExpenses(): void {
    this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          this.idProduct = el.idProducto;
          this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).setValue('');
          this.showGuaranteeTable = this.utilsExtended.resetTable(this.FORM_DATA, this.insureSelected);
          this.hideGuaranteeTable = this.utilsExtended.checkShowGuaranteeTable(this.FORM_DATA, this.insureSelected);
          this.getSobreprimas();
          this.resetGuaranteeSelection();
        })
      ).subscribe();
  }
  /**
   * @descriptionget obtener un seguro mayor de 70 años
   */
  getInsuredOlderThan70years(): void {
    this.FORM_DATA.get([this.insureSelected, 'insuredOlderThan70years']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          this.Utils.validNumberOfInsured(this.FORM_DATA, this.insureSelected, this.displayModal2,
            this.showModal2, this.sportChange);
        })
      ).subscribe();
  }
  /**
   * @descriptionget obtener un seguro deportes de riesgo
   */
  getInsuredsPlayRiskSports(): void {
    this.FORM_DATA.get([this.insureSelected, 'insuredsPlayRiskSports']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          this.sportChange = { name: 'sport', value: el };
          this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).setValue('');
          this.Utils.validNumberOfInsured(this.FORM_DATA, this.insureSelected, this.displayModal2,
            this.showModal2, this.sportChange);
          this.showGuaranteeTable = this.utilsExtended.resetTable(this.FORM_DATA, this.insureSelected);
          this.hideGuaranteeTable = this.utilsExtended.checkShowGuaranteeTable(this.FORM_DATA, this.insureSelected);
          this.resetGuaranteeSelection();
        })
      ).subscribe();
  }

  /**
   * Get pet insureds
   */
  getPetInsureds(): void {
    if (this.insureSelected === 'particularTravelAsistance' || this.insureSelected === 'individualTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'petInsureds']).valueChanges
        .pipe(
          takeUntil(this.finish),
          tap((num: any) => {
            this.petInsuredsChange = num;
            this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).setValue('');
            if (this.idProduct && num !== '') {
              this.showGuaranteeTable = this.utilsExtended.resetTable(this.FORM_DATA, this.insureSelected);
              this.hideGuaranteeTable = this.utilsExtended.checkShowGuaranteeTable(this.FORM_DATA, this.insureSelected);
            }
            this.resetGuaranteeSelection();

          })
        ).subscribe();
    }
  }
  /**
   * @description recuperar datos pais de destino
   */
  getCountryDestinyFormData(): void {
    this.FORM_DATA.get([this.insureSelected, 'countryDestiny']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((country: SelectMultipleValueModel) => {
          this.countryChange = { name: 'countryRisk', value: country };
          // reseteamos la lista de ambitos de paises
          if (this.countryDestinyMulti) {
            this.FORM_DATA.get([this.insureSelected, 'countryDestinyEnvironment']).setValue([]);
            if (!this.isOrigenSpain) {
              this.Utils.getEnvironmentCountry(country, [this.insureSelected, 'countryDestinyEnvironment'], this.FORM_DATA, this.apSrv);
            } else {
              this.Utils.getEnvironmentCountry(country, [this.insureSelected, 'countryDestinyEnvironment'], this.FORM_DATA, this.apSrv);
            }
          } else {
            if (!this.countryDestinyMulti && country.id !== undefined) {
              this.FORM_DATA.get([this.insureSelected, 'countryDestinyEnvironment']).setValue(country.id);
            }
          }
        })
      ).subscribe();
  }
  /**
   * @description recuperar datos pais de origen
   */
  getCuntryOrigin(): void {
    this.FORM_DATA.get([this.insureSelected, 'countryOrigin']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((country: SelectMultipleValueModel) => {
          this.countryChange = { name: 'countryRisk', value: country };
          // reseteamos la lista de ambitos de paises
          const dataSpain: any[] = [];
          dataSpain.push({ id: Numbers.number67, name: 'España', code: 'España' });
          // dataSpain.push( { name: 'España', id: 19001 } );
          if (country.name === 'España') {
            this.isOrigenSpain = true;
            this.disabledDestiny = false;
          } else {
            this.isOrigenSpain = false;
            this.disabledDestiny = true;
          }
          this.FORM_DATA.get([this.insureSelected, 'countryOriginEnvironment']).setValue('');
          this.Utils.getEnvironmentCountry(country, [this.insureSelected, 'countryOriginEnvironment'], this.FORM_DATA, this.apSrv);
          if (!this.isOrigenSpain) {
            this.destinyChange = { name: 'destiny', value: dataSpain };
          }
        })
      ).subscribe();
  }
  /**
   * @description recuperar datos pais de viaje
   */
  getCurrentlyTraveling(): void {
    this.FORM_DATA.get([this.insureSelected, 'currentlyTraveling']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el) => {
          if (this.FORM_DATA.get([this.insureSelected, 'currentlyTraveling']).value) { this.validDates(); }
        })
      ).subscribe();
  }

  /**
   * getDateStart
   */
  getDateStart(): void {
    this.FORM_DATA.get([this.insureSelected, 'dateStart']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el) => {
          if (this.FORM_DATA.get([this.insureSelected, 'currentlyTraveling']).value) { this.validDates(); }
        })
      ).subscribe();
  }

  /**
   * getDateEnd
   */
  getDateEnd(): void {
    this.FORM_DATA.get([this.insureSelected, 'dateEnd']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el) => {
          if (this.FORM_DATA.get([this.insureSelected, 'currentlyTraveling']).value) { this.validDates(); }
        })
      ).subscribe();
  }

  /**
   * getAllInsuredSameFamiliarUnit
   */
  getAllInsuredSameFamiliarUnit(): void {
    this.FORM_DATA.get([this.insureSelected, 'allInsuredSameFamiliarUnit']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          if (this.FORM_DATA.get([this.insureSelected, 'allInsuredSameFamiliarUnit']).value) {
            this.reloadNumberOfInsurables(Numbers.number2, Numbers.number10);
            this.showGuaranteeTable = this.utilsExtended.resetTable(this.FORM_DATA, this.insureSelected);
            this.hideGuaranteeTable = this.utilsExtended.checkShowGuaranteeTable(this.FORM_DATA, this.insureSelected);
            this.resetGuaranteeSelection();
          } else {
            this.reloadNumberOfInsurables();
          }
        })
      ).subscribe();
  }

  /**
   * getHasCodeDerogation
   */
  getHasCodeDerogation(): void {
    this.FORM_DATA.get([this.insureSelected, 'hasCodeDerogation']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          const derogaField: any = this.FORM_DATA.get([this.insureSelected, 'hasCodeDerogation']).value;
          this.requireChangeV = false;
          if (derogaField === true) { this.requireChangeV = true; }
          if (derogaField) {
            this.FORM_DATA.get(this.FORM_CONFIG.derogationCodes.linkFormPath).setValidators([Validators.required]);
            this.FORM_DATA.get(this.FORM_CONFIG.derogationCodes.linkFormPath).updateValueAndValidity();
          } else {
            this.FORM_DATA.get(this.FORM_CONFIG.derogationCodes.linkFormPath).clearValidators();
            this.FORM_DATA.get(this.FORM_CONFIG.derogationCodes.linkFormPath).updateValueAndValidity();
          }
        })
      ).subscribe();
  }

  /**
   * setDataStep
   */
  setDataStep(): void {
    this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).setValue(
      this.formDataValue.guaranteeLimitOfMedicalExpenses
    );
  }

  /**
   * validDates
   */
  validDates(): void {
    if (this.formDataValue.dateStart !== '' && this.formDataValue.dateEnd !== '' &&
        this.FORM_DATA.get([this.insureSelected, 'insuranceTime']).value < Numbers.number3) {
      this.Utils.showModalDialog(this.displayModal3, this.showModal3);
      this.FORM_DATA.get([this.insureSelected, 'currentlyTraveling']).setValue(false);
    }
  }

  /**
   * getSobreprimas
   */
  getSobreprimas(): void {
    this.sobreprimasSrv.getSobreprimaList(
      this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value)
      .pipe(take(1))
      .subscribe((sobreprimas: any) => {
        this.sobreprimasList = sobreprimas;
        if (this.FORM_DATA.get([this.insureSelected, 'allInsuredSameFamiliarUnit']).value) {
          this.reloadNumberOfInsurables(Numbers.number2, Numbers.number10);
        } else {
          this.reloadNumberOfInsurables();
        }
      });
  }

  /**
   * reloadNumberOfInsurables
   * @param min min
   * @param max max
   */
  reloadNumberOfInsurables(min?: number, max?: number): void {
    const canBeInsured: any[] = [];
    let minV = 0;
    if (min !== undefined) {
      minV = min;
    }
    let maxV = 0;
    if (max !== undefined) {
      maxV = max;
    }
    if (minV !== 0 && maxV !== 0) {
      for (let index: number = minV; index <= maxV; index++) {
        canBeInsured.push({ name: `${index}`, id: index });
      }
      this.FORM_CONFIG.numberOfInsured.options.list = canBeInsured;
      this.FORM_DATA.get([this.insureSelected, 'numberOfInsuredList']).setValue(canBeInsured);
      if (this.FORM_DATA.get([this.insureSelected, 'numberOfInsured']).value.id <= Numbers.number10 &&
      this.FORM_DATA.get([this.insureSelected, 'numberOfInsured']).value.id > Numbers.number1) {
        this.sportChange = { name: 'sport-70', value: this.FORM_DATA.get([this.insureSelected, 'insuredsPlayRiskSports']).value };
        this.numInsuredChange = { name: 'num-insured', value: this.FORM_DATA.get([this.insureSelected, 'numberOfInsured']).value };
      } else {
        this.sportChange = { name: 'sport-70', value: { name: '' } };
        this.numInsuredChange = { name: 'num-insured', value: { name: '' } };
      }

    } else {
      if (this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value !== '' &&
          this.formDataValue.guaranteeLimitOfMedicalExpenses) {
        for (let index = 1; index <= this.formDataValue.guaranteeLimitOfMedicalExpenses.numMaxAsegurados; index++) {
          canBeInsured.push({ name: `${index}`, id: index });
        }

      } else {
        for (let index = 1; index <= Numbers.number100; index++) {
          canBeInsured.push({ name: `${index}`, id: index });
        }
      }
      this.FORM_DATA.get([this.insureSelected, 'numberOfInsuredList']).setValue(canBeInsured);
    }
  }

  /**
   * dataEmit
   * @param ev ev
   */
  dataEmit(ev: any): void {
    if (ev && ev.enter) {
      this.utilsExtended.checkCodePromotional(this.FORM_DATA.get(this.FORM_CONFIG.codePromotional.linkFormPath).value,
      this.utilsExtended.promotionChange, this.vdSrv);
    }
  }

  /**
   * resetGuaranteeSelection
   */
  resetGuaranteeSelection(): void {
    const inputs = ['vacationRefund', 'lostOrStolenLuggage', 'deathAndDisability', 'tripCancellation'];
    const valueMsg = '';
    this.Utils.setInputsValue(inputs, this.FORM_DATA, this.insureSelected, valueMsg);
  }

  /**
   * clickButton
   * @param ev ev
   */
  public async clickButton(ev: 'back' | 'next'): Promise<void> {
    const auxPromoVal: any = this.FORM_DATA.get([this.insureSelected, 'codePromotional']).value;
    if (auxPromoVal !== '') {
      this.utilsExtended.checkCodePromotional2(auxPromoVal, this.vdSrv);

      setTimeout(() => {
        if (this.utilsExtended.checkPromoS) {
          this.prepareAndEmitev(ev);
        }
      }, Numbers.number350);
    } else {
      this.prepareAndEmitev(ev);
    }
  }

  /**
   * prepareAndEmitev
   * @param ev ev
   */
  prepareAndEmitev(ev: any): void {

    this.Utils.callCotizar(this.formDataValue, this.FORM_CONFIG, this.insureSelected, this.productosCorreduria);
    this.Utils.datalayer(this.FORM_DATA.get('insureSelected').value);
    this.CLICK_BTN.emit(ev);
  }

  /**
   * hasDerogationCode
   * @returns returns
   */
  hasDerogationCode(): boolean {
    let hasDerogationCode: boolean;
    if (this.FORM_DATA.get([this.insureSelected, 'hasCodeDerogation']).value === null) {
      hasDerogationCode = false;
    } else {
      hasDerogationCode = this.FORM_DATA.get([this.insureSelected, 'hasCodeDerogation']).value;
    }
    return hasDerogationCode;
  }

  /**
   * Get pets insurance
   */
  getHasPetsInsurance(): void {
    if (this.insureSelected === 'particularTravelAsistance' || this.insureSelected === 'individualTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'hasPetsInsurance']).valueChanges
          .pipe(
            takeUntil(this.finish),
            tap(el => {
              if (!el) {
                this.FORM_DATA.get([this.insureSelected, 'petInsureds']).setValue('');
              }
            })
          ).subscribe();
    }
  }

  /**
   * Check if user has pets
   * @returns true/false
   */
  hasPetsInsurance(): boolean {
    if (this.insureSelected === 'particularTravelAsistance' || this.insureSelected === 'individualTravelAsistance') {
      let hasPetsInsurance: boolean;
      if (this.FORM_DATA.get([this.insureSelected, 'hasPetsInsurance']).value === null || this.FORM_DATA.get([this.insureSelected, 'hasPetsInsurance']).value === false ) {
        this.petInsuredsChange = '';
        hasPetsInsurance = false;
      } else {
        hasPetsInsurance = this.FORM_DATA.get([this.insureSelected, 'hasPetsInsurance']).value;
      }
      return hasPetsInsurance;
    }
  }
  /**
   * radioS
   * @param ev ev
   */
  radioS(ev: any): void {
    const result: any = this.Utils.radioS(ev, this.FORM_DATA, this.insureSelected);
    this.countryDestinyMulti = result.countryDestinyMulti;
    this.maxDate = result.maxDate;
  }

  /**
   * downloadFileService
   * @param id id
   */
  downloadFileService(id: any): void {
    if (id > 0) {
      this.Utils.downloadFileUtil(id, this.document, this.documentsConst);
    }
  }

  /**
   * Invalid Button
   */
  checkFamily(): void {
    this.isInvalid = true;
    if (this.formDataValue.numberOfInsured && !this.formDataValue.numberOfInsured.id) {
      this.FORM_DATA.get([this.insureSelected, 'numberOfInsured']).setValue('');
    }
    if (this.FORM_DATA.get(this.insureSelected).valid) { this.isInvalid = false; }
  }
}
